import { render, staticRenderFns } from "./MyCourseItem.vue?vue&type=template&id=74e0d204&scoped=true&"
import script from "./MyCourseItem.vue?vue&type=script&lang=js&"
export * from "./MyCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseItem.vue?vue&type=style&index=0&id=74e0d204&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e0d204",
  null
  
)

export default component.exports